export default __webpack_public_path__ + "static/media/blue_business_chat.25f45de3.svg";